(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sa-contact-inquiries"] && !Shopify.designMode) return;
  try {
    
  (()=>{const close=()=>{document.querySelectorAll('.lookbook-shop__dialog:not([hidden])').forEach((dialog)=>dialog.hidden=true);document.documentElement.style.overflow=''};document.addEventListener('click',(event)=>{const opener=event.target.closest('[data-lookbook-open]');if(opener){const dialog=document.getElementById(opener.dataset.lookbookOpen);if(dialog){dialog.hidden=false;document.documentElement.style.overflow='hidden';dialog.querySelector('[data-lookbook-close]')?.focus()}}if(event.target.closest('[data-lookbook-close],.lookbook-shop__backdrop'))close()});document.addEventListener('keydown',(event)=>{if(event.key==='Escape')close()})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sa-inside-video-scroll"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jnby-video-scroll')) {
    customElements.define('jnby-video-scroll', class extends HTMLElement {
      connectedCallback() {
        this.copy = this.querySelector('.jvs-copy');
        this.header = document.querySelector('[data-sa-header-bar]');
        if (!this.copy) return;
        this.update = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => {
            if (!this.isConnected || !matchMedia('(min-width: 1000px)').matches) return;
            const top = this.header ? this.header.getBoundingClientRect().height : 0;
            const height = Math.max(1, document.documentElement.clientHeight - top);
            const copyHeight = this.copy.getBoundingClientRect().height;
            const textTop = Math.max(0, (height - copyHeight) / 2);
            this.style.setProperty('--jvs-top', top + 'px');
            this.style.setProperty('--jvs-height', height + 'px');
            this.style.setProperty('--jvs-text-top', textTop + 'px');
            this.style.setProperty('--jvs-hold', (textTop + copyHeight + 24) + 'px');
          });
        };
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.copy);
        if (this.header) this.observer.observe(this.header);
        this.observer.observe(document.documentElement);
        window.addEventListener('resize', this.update, { passive: true });
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('resize', this.update);
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
